import ActionsForm from '@/shared/mixins/actionsForm'
import atividade from '@/shared/http/repositories/business/aprAtividade'
import atividadeDescricao from '@/shared/http/repositories/business/aprActivityDescription'
import template from '@/shared/http/repositories/business/aprTemplate'
import { loading, toast } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools'

export default {
  name: 'newTemplate',
  mixins: [ActionsForm],
  props: {
    clonagemTabela: {
      type: Boolean,
      required: false,
      default: false
    },
    editar: {
      type: Boolean,
      required: false,
      default: false
    },
    clone: {
      type: String,
      default: null
    },
    templateid: {
      type: String,
      default: null
    },
    descricao: {
      type: String,
      default: null
    },
    categoria: {
      type: String,
      default: null
    }
  },
  components: {},
  data () {
    return {
      cancelarAddTemplateApr: false,
      form: {
        categoria: this.categoria === undefined || this.categoria === null ? null : this.categoria,
        descricao: this.descricao === undefined || this.descricao === null ? null : this.descricao
      },
      dataAtividade: [],
      dataAtividadeDescricao: [],
      clonagemGerada: {}
    }
  },

  watch: {
  },

  mounted () {
    this.onLoadAtividade()
    this.onLoadAtividadeDescricao()
  },
  methods: {
    cancel () {
      this.cancelarAddTemplateApr = !this.cancelarAddTemplateApr
      this.$emit('cancelarAddTemplate', this.cancelarAddTemplateApr)
    },
    onLoadAtividade () {
      loading.push()
      atividade.GetAtividades()
        .then((Response) => {
          loading.pop()
          this.dataAtividade = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onLoadAtividadeDescricao () {
      loading.push()
      atividadeDescricao.GetDescricaoWeb()
        .then((Response) => {
          loading.pop()
          this.dataAtividadeDescricao = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    postCriarTemplateWeb () {
      if (this.clone != null) {
        this.postClonarTemplateWeb()
      } else {
        loading.push()
        if (this.form.descricao == null || this.form.categoria == null) {
          loading.pop()
          toast.warning('Por favor selecione uma Atividade e Descricao para gerar um novo Template!')
        } else {
          template.CriarNovoTemplateWeb(this.form.descricao, this.form.categoria)
            .then((Response) => {
              this.form.categoria = null
              this.form.descricao = null
              loading.pop()
              this.dataAtividadeDescricao = Response.data
              this.$emit('recarregarTable', true)
            })
            .catch(Error => {
              loading.pop()
              toast.warning(Error.response.data)
            })
        }
      }
    },
    postClonarTemplateWeb () {
      loading.push()
      if (this.form.descricao == null || this.form.categoria == null) {
        loading.pop()
        toast.warning('Por favor selecione uma Atividade e Descricao para gerar um novo Template!')
      } else {
        template.ClonarTemplateWeb({TemplateID: this.clone, AtividadeDescricaoID: this.form.descricao, AtividadeID: this.form.categoria})
          .then((Response) => {
            this.clonagemGerada = Response.data
            loading.pop()
            if (this.clonagemTabela === true) {
              toast.success('Clonagem realizada com sucesso')
              this.$emit('recarregarTable', true)
            } else {
              this.$refs['msg-clonagem'].show()
            }
          })
          .catch(Error => {
            loading.pop()
            toast.warning(Error.response.data)
            this.cancel()
          })
      }
    },
    postEditarTemplateWeb () {
      loading.push()
      if (this.form.descricao == null || this.form.categoria == null) {
        loading.pop()
        toast.warning('Por favor selecione uma Atividade e Descricao para gerar um novo Template!')
      } else {
        template.EditarTemplateWeb({TemplateID: this.templateid, AtividadeDescricaoID: this.form.descricao, AtividadeID: this.form.categoria})
          .then((Response) => {
            this.clonagemGerada = Response.data
            loading.pop()
            if (this.clonagemTabela === true) {
              toast.success('Edição realizada com sucesso')
              this.$emit('recarregarTable', true)
            } else {
              this.$refs['msg-clonagem'].show()
            }
          })
          .catch(Error => {
            loading.pop()
            toast.warning(Error.response.data)
            this.cancel()
          })
      }
    },
    keepPage () {
      this.cancel()
      this.$emit('recarregarTable', true)
      this.$refs['msg-clonagem'].hide()
    },
    goToClone () {
      this.$emit('clonagemTemplate', this.clonagemGerada)
      this.$refs['msg-clonagem'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/newTemplate/newTemplate.js